import '../chart-grid/ChartGrid.css';
import './SelectionArea.css';
export var brushOverlay = '_efl7nz0-3-5-0 _13lzg4k0-3-5-0';
export var knob = '_efl7nz1-3-5-0';
export var selectionArea = '_efl7nz3-3-5-0';
export var transparentDraggingArea = '_efl7nz2-3-5-0';